import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Download, FileText } from "lucide-react";

export default function TutorItem() {
  const { id } = useParams();
  const [item, setItem] = useState(null);

  useEffect(() => {
    api.get(`/api/tutor/items/${id}`).then(({ data }) => setItem(data));
    // re-fetch on id change; setItem is stable
  }, [id]);

  const downloadPdf = (withAnswers) => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tutor/items/${id}/pdf${withAnswers ? "?with_answers=true" : ""}`,
      { headers: { Authorization: `Bearer ${localStorage.getItem("tmo_token")}` }})
      .then((r) => r.blob())
      .then((b) => {
        const url = URL.createObjectURL(b);
        const a = document.createElement("a");
        a.href = url; a.download = `${item.kind}-${id.slice(0,8)}.pdf`;
        document.body.appendChild(a); a.click(); a.remove();
        URL.revokeObjectURL(url);
      });
  };

  if (!item) return <div className="p-6 text-sm text-[#4B5563]" data-testid="item-loading">Loading…</div>;
  const p = item.payload;

  const canPdf = ["worksheet", "quiz", "test"].includes(item.kind);

  return (
    <div data-testid="tutor-item">
      <Link to="/tutor" className="text-sm text-[#D92D20] inline-flex items-center gap-1"><ArrowLeft className="w-3.5 h-3.5" /> Dashboard</Link>
      <h1 className="font-display font-black text-3xl md:text-4xl mt-2 capitalize">{item.kind} · {p.title || item.meta?.topic}</h1>
      <div className="text-xs text-[#4B5563]">{new Date(item.created_at).toLocaleString()}</div>

      {canPdf && (
        <div className="mt-4 flex gap-2">
          <button data-testid="item-pdf" onClick={() => downloadPdf(false)} className="btn-outline inline-flex items-center gap-2 text-sm">
            <Download className="w-4 h-4" /> PDF
          </button>
          <button data-testid="item-pdf-key" onClick={() => downloadPdf(true)} className="btn-outline inline-flex items-center gap-2 text-sm">
            <FileText className="w-4 h-4" /> PDF + Answer key
          </button>
        </div>
      )}

      <pre className="mt-6 bg-white border border-[#E5E7EB] rounded-2xl p-4 text-xs overflow-auto" data-testid="item-raw">
        {JSON.stringify(p, null, 2)}
      </pre>
    </div>
  );
}
